import { render, staticRenderFns } from "./StatsByRule.vue?vue&type=template&id=4c80c340"
import script from "./StatsByRule.vue?vue&type=script&lang=js"
export * from "./StatsByRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports